<template>
    <rkm-modal
        :title="`Local de atendimento agendador - ${item && item.unidadeNomeFantasia}`"
        extra-large
        ref="RkmModal"
    >
        <rkm-form
            ref="RkmForm"
            show-legend
        >
            <rkm-row>
                <rkm-col>
                    <rkm-form-select
                        :options="data.form.unidades"
                        :validations="validations.unidade"
                        @change="handleUnidadeChange"
                        label="Unidade"
                        show-default-option
                        text-field="nomeFantasia"
                        v-model="model.unidadeId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col>
                    <rkm-form-select
                        :options="data.form.infraestruturas"
                        :validations="validations.infraestrutura"
                        label="Local de atendimento"
                        show-default-option
                        text-field="nome"
                        v-model="model.infraestruturaId"
                        value-field="id"
                    />
                </rkm-col>

                <rkm-col cols="auto">
                    <rkm-button
                        :label="false"
                        @click="include"
                        color="primary"
                    >
                        Incluir
                    </rkm-button>

                    <rkm-button
                        :label="false"
                        @click="clean"
                    >
                        Limpar
                    </rkm-button>
                </rkm-col>
            </rkm-row>
        </rkm-form>

        <rkm-row>
            <rkm-col>
                <rkm-table
                    :fields="fields"
                    :items="model.infraestruturasAgendadoras"
                >
                    <template v-slot:cell(ocupacao)="{item}">
                        {{item.codigo}} - {{item.nome}}
                    </template>

                    <template v-slot:cell(actions)="{index}">
                        <rkm-button
                            @click="destroy(index)"
                            color="danger"
                            small
                            title="Excluir"
                        >
                            <rkm-icon icon="trash" />
                        </rkm-button>
                    </template>
                </rkm-table>
            </rkm-col>
        </rkm-row>

        <template v-slot:footer="{cancel}">
            <rkm-button @click="cancel">
                Cancelar
            </rkm-button>

            <rkm-button
                @click="save"
                color="primary"
            >
                Salvar
            </rkm-button>
        </template>
    </rkm-modal>
</template>

<script>
// Mixins.
import {error, object, repository, stringCase} from '@/mixins'

// Vuex.
import {mapActions} from 'vuex'

export default {
    computed: {
        validations() {
            return {
                unidade: {required: true},
                infraestrutura: {required:true},
            }
        },
    },
    created() {
        this.repositories = {
            parametrizacao: this.getConectaSusRepository('ambulatorio.parametrizacao'),
        }
    },
    data: () => ({
        fields: [
            {key: 'unidadeNomeFantasia', label: 'Unidade', sortable: true},
            {key: 'nome', label: 'Local de atendimento', sortable: true},
            {class: 'col-min text-center', key: 'actions', label: 'Ações'},
        ],
        item: null,
        model: {
            unidadeId: null,
            infraestruturaId: null,
            infraestruturasAgendadoras: [],
        },
    }),
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        open(item) {
            this.resetForm()

            this.item = item

            this.model.infraestruturasAgendadoras = this.clone(item.infraestruturasAgendadoras)

            this.$refs.RkmModal.show()
        },
        handleUnidadeChange(value) {
            this.data.form.infraestruturas = []
            this.model.infraestruturaId = null

            if (value === null) return

            const request = {
                origem: 'infraestrutura',
                listar: 'infraestruturas',
                unidadeId: value,
            }

            this.setLoading()

            this.repositories.parametrizacao.list(this.camelObjectKeysToSnakeRecursive(request))
                .then(response => {
                    this.data.form.infraestruturas = response.data

                    if (response.data.length === 1) {
                        this.model.infraestruturaId = response.data[0].id
                    }
                })
                .catch(this.handleError)
                .finally(() => this.unsetLoading())
        },
        store() {
            this.$refs.RkmForm.validate()
                .then(valid => {
                    if (valid === false) return

                    if (this.model.infraestruturaId === this.item.id) {
                        this.showValidationNotification('O local de atendimento agendador não pode ser o mesmo que o local de atendimento.')
                        return
                    }
                    else if (this.model.infraestruturasAgendadoras && this.model.infraestruturasAgendadoras.find(infraestruturaAgendadora => infraestruturaAgendadora.id === this.model.infraestruturaId)) {
                        this.showValidationNotification('O local de atendimento já foi incluído.')
                        return
                    }

                    const unidade = this.data.form.unidades.find(unidade => unidade.id === this.model.unidadeId)
                    const infraestrutura = this.data.form.infraestruturas.find(infraestrutura => infraestrutura.id === this.model.infraestruturaId)

                    this.model.infraestruturasAgendadoras.push({
                        id: infraestrutura.id,
                        unidadeNomeFantasia: unidade.nomeFantasia,
                        nome: infraestrutura.nome,
                    })

                    this.resetForm()
                })
        },
        include() {
            this.store()
        },
        destroy(index) {
            this.showDeleteConfirmation('Deseja realmente excluir o local de atendimento?', async () => {
                this.model.infraestruturasAgendadoras.splice(index, 1)
            })
        },
        save() {
            this.item.infraestruturasAgendadoras = this.model.infraestruturasAgendadoras

            this.$refs.RkmModal.hide()
        },
        clean() {
            this.resetForm()
        },
        resetForm() {
            this.data.form.infraestruturas = []
            this.model.unidadeId = null
            this.model.infraestruturaId = null

            this.$nextTick().then(() => this.$refs.RkmForm.resetValidator())
        },
    },
    mixins: [error, object, repository, stringCase],
    props: {
        data: {type: Object, required: true},
    },
}
</script>